import { createClient } from '@supabase/supabase-js';

// Recupera le credenziali dalle variabili d'ambiente
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabaseKey) {
  console.warn('⚠️ Supabase credentials not found. Please check your environment variables.');
}

// Crea il client Supabase
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    headers: {
      'x-client-info': 'metodobianchini-web',
    },
  },
});

// Alias per compatibilità con il codice esistente
export const supabaseClient = supabase;

// Helper per verificare la connessione
export async function testSupabaseConnection() {
  try {
    const { data, error } = await supabase.from('_test_').select('count').limit(1);
    if (error && error.code !== 'PGRST204') {
      console.log('✅ Supabase connesso correttamente');
      return true;
    }
    return true;
  } catch (err) {
    console.error('❌ Errore connessione Supabase:', err);
    return false;
  }
}
